import { useState } from 'react'

import {
  Box,
  Drawer,
  Toolbar,
  useMediaQuery,
  useTheme,
} from '@mui/material'
import { Outlet } from 'react-router-dom'

import { SidebarNav } from './SidebarNav'
import { TopBar } from './TopBar'
import { useRealtimeSubscriptions } from '@/hooks/useRealtimeSubscriptions'
import { IncomingChatNotificationContainer } from '@/features/notifications/components/IncomingChatNotificationContainer'

const DRAWER_WIDTH = 264

export const AppLayout = () => {
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))
  const [mobileOpen, setMobileOpen] = useState(false)

  useRealtimeSubscriptions()

  const handleSidebarToggle = () => {
    setMobileOpen((prev) => !prev)
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <TopBar onOpenSidebar={handleSidebarToggle} drawerWidth={DRAWER_WIDTH} />
      <Box
        component="nav"
        sx={{
          width: { lg: DRAWER_WIDTH },
          flexShrink: { lg: 0 },
        }}
        aria-label="navigation"
      >
        <Drawer
          variant={isLargeScreen ? 'permanent' : 'temporary'}
          open={isLargeScreen || mobileOpen}
          onClose={handleSidebarToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            '& .MuiDrawer-paper': {
              width: DRAWER_WIDTH,
              borderRight: '1px solid',
              borderColor: 'divider',
              boxSizing: 'border-box',
              bgcolor: 'background.paper',
            },
          }}
        >
          <SidebarNav
            onNavigate={() => {
              if (!isLargeScreen) {
                setMobileOpen(false)
              }
            }}
          />
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          px: { xs: 2, md: 4 },
          py: { xs: 3, md: 4 },
          width: { xs: '100%', lg: `calc(100% - ${DRAWER_WIDTH}px)` },
          minHeight: '100vh'
        }}
      >
        <Toolbar />
        <Outlet />
      </Box>
      <IncomingChatNotificationContainer />
    </Box>
  )
}
